// App.js
import React from 'react';
import Navbar from './Navbar'; // Import the Navbar component
import Footer from "./Footer";
import Post from "./Post";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Blog from "./Blog Page/Blog";
import Home from"./Home Page/Home";
import './App.css';

function App() {
  return (
    <Router> 
      <div>
        
        <Navbar /> {/* Include the Navbar component */}
        {/* Your other application content */}
        <Routes>
          <Route exact path="/" element={<Home/>} />
          <Route path="/blog" element={<Blog/>} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;

